import React from 'react';
import { connect } from 'react-redux';
import { BasePageStyles } from '../../../hooks/styles'
import { Button, ClickAwayListener, Divider, Grow, MenuItem, MenuList, Paper, Popper, SwipeableDrawer, TextField } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useHistory } from 'react-router-dom';
import { OrderActions } from '../../../redux/actions';
import config from '../../../config';
import { useMediaQuery } from 'react-responsive';
import MenuIcon from '@mui/icons-material/Menu';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { useCart } from "react-use-cart";
import SearchAndCart from './searchAndCart'; 

interface MenuListProps {}

const MenuListComposition = (props: MenuListProps) => {
  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-device-width: 900px)'
  })
  const classes = BasePageStyles();
  const history = useHistory()
  
  const [openDrawer, setOpenOpenDrawer] = React.useState(false);
  const [onTrackingPage, setOnTrackingPage] = React.useState(false);
   const [onOrderWallUnitPage, setOnOrderWallUnitPage] = React.useState(false);
const [onOrderPage, setOnOrderPage] = React.useState(false);



	const routeChange = (path: string) =>{ 
		history.push(path);
	}

  const renderContactButton = () => {
    return (
      <Button
        onClick={() => window.location.href = `${config.wordpressUrl}/contact`}
        className={'contactButton'}
        variant="contained"
        size='large'
        style={{
          margin: 6
        }}
      >
        Contact Us
      </Button>
    )
  }

  React.useEffect(() => {
		// Fake onHover on links when user is on the referenced page
    switch(window.location.pathname) {
      case '/':
        setOnTrackingPage(false);
        setOnOrderWallUnitPage(false);
        setOnOrderPage(true);
        break
      case '/order':
        setOnTrackingPage(true);
        setOnOrderWallUnitPage(false);
        setOnOrderPage(false);
        break
      case '/order-wall-unit':
        setOnTrackingPage(false);
        setOnOrderWallUnitPage(true);
        setOnOrderPage(false);
        break
      default:
        setOnTrackingPage(false);
        setOnOrderWallUnitPage(false);
        setOnOrderPage(false);
        break
    }
	}, []);

  return (
    <div>
      {isDesktopOrLaptop ?
        <div style={{
            display: "flex",
            flexDirection: "row"
          }}>

        {/*<Button
            onClick={() => routeChange('/order-wall-unit')}
            className={onOrderWallUnitPage ? classes.fakeOnHoverNav : classes.profileMenuBtn}
          >
            Order Wall Unit
          </Button>

          <Button
            onClick={() => routeChange('/')}
            className={onOrderPage ? classes.fakeOnHoverNav : classes.profileMenuBtn}
          >
            Order Narcan®
          </Button>*/}
          <Button
            onClick={() => routeChange('/about')}
            className={classes.profileMenuBtn}
          >
            About Us
          </Button>

          

          <Button
            onClick={() => routeChange('/order')}
            className={onTrackingPage ? classes.fakeOnHoverNav : classes.profileMenuBtn}
          >
            Track Order
          </Button>
          {renderContactButton()}

          <SearchAndCart />
        </div>
        :
        <div>
          <MenuIcon onClick={() => setOpenOpenDrawer(!openDrawer)} fontSize='large'/>
          <SwipeableDrawer
            anchor={'top'}
            open={openDrawer}
            onClose={() => setOpenOpenDrawer(false)}
            onOpen={() => setOpenOpenDrawer(true)}
          >
            <MenuList>
              <MenuItem>
                <Button
                  onClick={() => routeChange('/order-wall-unit')}
                  className={onOrderWallUnitPage ? classes.fakeOnHoverNav : classes.profileMenuBtn}
                >
                  Order Wall Unit
                </Button>
                </MenuItem>
               <MenuItem>
                <Button
                  onClick={() => routeChange('/')}
                  className={onOrderPage ? classes.fakeOnHoverNav : classes.profileMenuBtn}
                >
                  Order Narcan®
                </Button>
               </MenuItem>
               <MenuItem>
                <Button
                  onClick={() => routeChange('/about')}
                  className={classes.profileMenuBtn}
                >
                  About Us
                </Button>
           </MenuItem>
               <MenuItem>
                <Button
                  onClick={() => routeChange('/order')}
                  className={classes.profileMenuBtn}
                >
                  Track Order
                </Button>
              </MenuItem>
              <Divider />
              <MenuItem>{renderContactButton()}</MenuItem>
              <SearchAndCart />
            </MenuList>
          </SwipeableDrawer>
        </div>
      }
    </div>
  );
}

const mapStateToProps = (state: any) => ({});

const mapDispatchToProps = (dispatch: any) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(MenuListComposition);


